module.exports = __webpack_public_path__ + "img/miaosha-icon.e7d1fb11.png";